import axios from "axios";
import { createHashHistory } from "history";
import packageJson from "../../../package.json";

export const history = createHashHistory();

const fetchClient = () => {
    const defaultOptions = {
        baseURL: process.env.REACT_APP_API_URL,
        method: "get",
        headers: {
            "Content-Type": "application/json"
        }
    };

    // Create instance
    let instance = axios.create(defaultOptions);

    // Set the AUTH token for any request
    instance.interceptors.request.use(function (config) {
        const token = localStorage.getItem("token");

        var language = "en";
        var crSettings = JSON.parse(localStorage.getItem("crSettings"));
        if (crSettings) {
            if (crSettings.language) {
                language = crSettings.language;
            }
        }

        config.headers = {
            "Content-Type": "application/json",
            Authorization: token ? `Bearer ${token}` : "",
            "X-CleaningReportApp-Version": packageJson.version,
            "Content-Language": language
        };

        return config;
    });

    instance.interceptors.response.use(
        response => successHandler(response),
        error => errorHandler(error)
    );

    const errorHandler = error => {
        if (error.response) {
            const { status } = error.response;

            if (status === 401) {
                localStorage.removeItem("token");
                history.replace("/login");
            }
        }

        return Promise.reject(error);
    };

    const successHandler = response => {
        return response;
    };

    return instance;
};

export default fetchClient();
